export default __webpack_public_path__ + "static/media/sidebar_dashboard_blue.978df950.svg";